export default {
    updateMinigameScore(state, payload) {
        state.minigameScore = payload;
    }
};